export default __webpack_public_path__ + "static/media/micking.c704dc56.png";